import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import OrderExplorer from './order-explorer/order-explorer';
import ActionsContainer from './shared/components/actions-container';
import { useSelectedColor } from './shared/hooks/use-selected-color';
import { View } from './shared/types';
import RoutesMonitoring from './routes-monitoring-screen/routes-monitoring/routes-monitoring';
import useMonitoringStore from './shared/hooks/use-monitoring-store';
import { etaCalculatorProvider } from 'bringg-web/features/monitoring/shared/utils/eta-calculator/eta-calculator-provider';
import { useStores } from 'bringg-web/recipes';

type MonitoringProps = {
	view: View;
};

const Monitoring = (props: MonitoringProps) => {
	const { view } = props;
	const { tagsStore, teamsStore, skillsStore, fleetsStore, servicePlansStore, userTypeStore } = useStores();

	const { setView, setInitDataLoaded } = useMonitoringStore();

	useEffect(() => {
		setView(view);
	}, [view, setView]);

	const { color } = useSelectedColor(view);

	const initData = async () => {
		await Promise.all([
			teamsStore.fetchAll(),
			tagsStore.fetchAll(),
			skillsStore.fetchAll(),
			fleetsStore.fetchAll(),
			servicePlansStore.fetchAll(),
			userTypeStore.fetchAll()
		]);

		setInitDataLoaded(true);
	};

	useEffect(() => {
		initData();
		etaCalculatorProvider.init();
	}, []);

	return (
		<>
			{view === View.tasks ? <OrderExplorer /> : <RoutesMonitoring />}
			<ActionsContainer selectedColor={color} />
		</>
	);
};

export default observer(Monitoring);
